module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "conversations",
    class: _vm.containerClass
  }, [(_vm.searchKeyedValues("is").length > 0 && _vm.conversationsUpdateCount > 0) ? _c('small', {
    staticClass: "followAccordionWidth"
  }, [_c('div', {
    staticClass: "tpadding text-muted text-center"
  }, [_vm._v(_vm._s(_vm.$tc('conversations.markAllAsRead.message', _vm.conversationsUpdateCount, {
    nb: _vm.conversationsUpdateCount
  })) + " "), _c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.markAllAsRead
    }
  }, [_vm._v(_vm._s(_vm.$t('conversations.markAllAsRead.button')))])])]) : _vm._e(), _c('float-btn', {
    staticClass: "btn-success"
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-h"
  }), _c('a', {
    staticClass: "btn btn-info clickable",
    on: {
      "click": _vm.showAll
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("conversations.allConversations")))])]), _c('a', {
    staticClass: "btn btn-warning clickable",
    on: {
      "click": _vm.showArchives
    }
  }, [_c('i', {
    staticClass: "fa fa-archive"
  }), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("conversations.archives")))])]), _c('a', {
    staticClass: "btn btn-primary clickable",
    on: {
      "click": _vm.showInbox
    }
  }, [_c('i', {
    staticClass: "fa fa-inbox"
  }), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("conversations.inbox")))])]), _c('a', {
    staticClass: "btn btn-success createBtn clickable",
    on: {
      "click": _vm.createConversation
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("conversations.createBtn")))])])]), _c('accordion', {
    ref: "accordion",
    staticClass: "paddingBottom mailbox",
    attrs: {
      "injected": _vm.injected,
      "container": "#body",
      "thresold": 50
    }
  }, [(_vm.conversationsStatus == _vm.STATUS.LOADING) ? _c('accordion-loading-header', {
    on: {
      "fire": _vm.doNothing
    }
  }, [_vm._v(_vm._s(_vm.$t("conversations.loading")))]) : _vm._e(), (_vm.conversationsStatus == _vm.STATUS.LOADED) ? [_vm._l((_vm.conversationsByMonth), function(monthAndConversations, index) {
    return [_c('accordion-subtitle', {
      attrs: {
        "group": "monthHeader"
      }
    }, [(monthAndConversations.month == "today") ? [_vm._v(_vm._s(_vm.$t('events.nearly.' + monthAndConversations.month)))] : (monthAndConversations.month == "week") ? [_vm._v(_vm._s(_vm.$t('events.nearly.' + monthAndConversations.month)))] : [_vm._v(_vm._s(_vm._f("ucfirst")(_vm._f("unixtimeTo")(monthAndConversations.convs[0].lastMessageTimeFixed, "MMMM YYYY"))))]], 2), _vm._l((monthAndConversations.convs), function(conversation) {
      return _c('conversation', {
        key: conversation.eternalId,
        ref: "conversationsRef",
        refInFor: true,
        attrs: {
          "conversation": conversation,
          "injected": false
        }
      })
    })]
  }), (_vm.hasNextConversations) ? [_c('h2'), _c('accordion-loading-header', {
    on: {
      "fire": _vm.loadNext
    }
  }, [_vm._v(_vm._s(_vm.$t("conversations.loading")))])] : _vm._e(), (_vm.conversations.length > 0 && !_vm.hasNextConversations) ? [_c('h2'), _c('div', {
    staticClass: "information-message"
  }, [_vm._v(_vm._s(_vm.$t("conversations.allLoaded")))])] : _vm._e(), (_vm.conversations.length === 0 && !_vm.hasNextConversations) ? [_c('accordion-subtitle', {
    attrs: {
      "group": "monthHeader"
    }
  }, [_vm._v(_vm._s(_vm.$t("conversations.noConversations")))]), _c('div', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.createConversation
    }
  }, [_vm._v(_vm._s(_vm.$t("conversations.createBtn")))])])] : _vm._e()] : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-021c23c4","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Conversations/Conversations.vue
// module id = 870
// module chunks = 13